module.exports = __webpack_public_path__ + "static/media/vc.9b9d4796.svg";